import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  inject,
  useContext,
  ComputedRef,
} from '@nuxtjs/composition-api';
import { IProject } from '~/types/project';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import ProjectExpansionsHero from '~/components/Films/ProjectExpansionsHero.vue';
import ProjectExpansionsPosters from '~/components/Films/ProjectExpansionsPosters.vue';
import ProjectExpansionsNFTPromoBar from '~/components/Films/ProjectExpansionsNFTPromoBar.vue';
import ProjectPrizesGrid from '~/components/Films/ProjectPrizesGrid.vue';
import LargeCTABackgroundPanel from '~/components/UIComponents/LargeCTABackgroundPanel.vue';
import { PosterOverview } from '~/types/collections';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectExpansionsTab',
  props: {
    projectSlug: null,
    project: null,
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  projectSlug: string;
  project: IProject;
  doc: ISanityDocuments[SanityDocumentSchema.PROJECT];
};



const { $sanityImage } = useContext();

const changeTab = inject<(tab: string) => void>('changeTab');

const handleChangeTab = (tab: string) => {
  if (changeTab) {
    changeTab(tab);
  }
};

const projectTitle = computed(() => props.project.title);

const posters: ComputedRef<PosterOverview[]> = computed(
  () =>
    props.project?.posters?.sort?.((a: PosterOverview, b: PosterOverview) =>
      a.posterId.localeCompare(b.posterId),
    ) || [],
);

const prizes = computed(() => {
  return props.doc?.prizesList;
});

const currPromo = computed(() => {
  return props.project.currentNftPromotion;
});

const fullScreenCTABackground = (image: any) => {
  return $sanityImage.urlFor(image.asset._ref).url();
};

const mbImages = {
  sm: fullScreenCTABackground(props.doc?.pageHeroImage),
  md: fullScreenCTABackground(props.doc?.pageHeroImage),
  lg: fullScreenCTABackground(props.doc?.pageHeroImage),
  xl: fullScreenCTABackground(props.doc?.pageHeroImage),
};

return { __sfc: true,props, $sanityImage, changeTab, handleChangeTab, projectTitle, posters, prizes, currPromo, fullScreenCTABackground, mbImages, ProjectExpansionsHero, ProjectExpansionsPosters, ProjectExpansionsNFTPromoBar, ProjectPrizesGrid, LargeCTABackgroundPanel }
}

})